'use strict';

var GridUndoButtonDirective = function GridUndoButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-undo-button.html'),
    controller: 'GridUndoButtonController'
  };
};
GridUndoButtonDirective.$inject = [];
module.exports = GridUndoButtonDirective;